// ** Auth Endpoints
export default {
  loginEndpoint: `${process.env.REACT_APP_LINK_AUTH}/auth/sign_in`,
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',
  tokenType: 'Bearer',
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  storageClientKeyName: 'client',
  storageUidName: 'uid',
};
